// Client-side mirror of the parts-quote server rules (400s: description_required,
// description_too_long, invalid_quantity; unverified needs a name plus phone or email).
export const QUOTE_DESCRIPTION_MIN = 5;
export const QUOTE_DESCRIPTION_MAX = 2000;

export interface PartsQuoteDraft {
  description: string;
  quantity: string;
  verified: boolean;
  name?: string;
  phone?: string;
  email?: string;
}

/** Returns the first validation message, or null when the draft can be sent. */
export function validatePartsQuote(d: PartsQuoteDraft): string | null {
  const desc = d.description.trim();
  if (desc.length < QUOTE_DESCRIPTION_MIN) return 'Tell us a little more about the part you need.';
  if (desc.length > QUOTE_DESCRIPTION_MAX) return `Keep the description under ${QUOTE_DESCRIPTION_MAX} characters.`;
  const qty = Number(d.quantity);
  if (!Number.isInteger(qty) || qty < 1 || qty > 999) return 'Quantity must be a whole number from 1 to 999.';
  if (!d.verified) {
    if (!d.name?.trim()) return 'Enter your name so the parts desk knows who to call.';
    if (!d.phone?.trim() && !d.email?.trim()) return 'Enter a phone number or email so we can reach you.';
  }
  return null;
}

/** "oil_filter" / "OIL-FILTER" -> "Oil filter". */
export function humanizePartFunction(raw: string | null | undefined): string {
  const words = (raw ?? '').replace(/[_-]+/g, ' ').trim().toLowerCase();
  return words ? words[0].toUpperCase() + words.slice(1) : 'Part';
}
